import React from 'react'

import { NavLink } from 'react-router-dom'

import { List, ListItem, ListItemText, useTheme } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	listItem: {
		fontFamily: 'Nunito',
		fontSize: 16,
		color: '#3B0275',
		opacity: 0.6,
		fontWeight: 'bold !important'
	}
}))

const ClientNavLinks = (props) => {
	const { selectedFacility, client, roles } = props
	const classes = useStyles()
	const isGroomer = roles.length === 1 && roles.includes('Groomer')

	return (
		<List className={classes.defaultNav}>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/clients/${client ? client._id : null}/appointments`}>
				<ListItemText primary="Appointments" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/clients/${client ? client._id : null}/contacts`}>
				<ListItemText primary="Contacts" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				exact
				to={`/clients/${client ? client._id : null}/household`}>
				<ListItemText primary="Household" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/clients/${client ? client._id : null}/pets`}>
				<ListItemText primary="Pets" />
			</ListItem>
			{ isGroomer ? null : (
				<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/clients/${client ? client._id : null}/membership`}>
				<ListItemText primary="Social Access" />
			</ListItem> 
			) 
			}
			{ isGroomer ? null : (
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/clients/${client ? client._id : null}/payments`}>
				<ListItemText primary="Payments" />
			</ListItem> ) 
			}
			{
				isGroomer ? null : (
				<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/clients/${client ? client._id : null}/household/data`}>
				<ListItemText primary="Household Data" />
			</ListItem>) 
			}
		</List>
	)
}

export default ClientNavLinks
